module.exports = __webpack_public_path__ + "images/screen-shots/team-21a0ea5c5dc82d11ff03f9bbe57f3993.jpg";